var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaihhalflogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 744,
    viewBox: "0 0 701 744",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8712_49370)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 468H195L255 744H269L327 399L341 462H350L363 399L371 438H391L405 119L435 321L471 390C471 390 483 414 492 458H701V445H514C514 445 504 404 492 381L454 314L403 0H394L376 372L368 321H355L349 399L337 301H319L266 653H258L215 456L0 455V469L8 468Z",
    fill: "#00A751"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8712_49370"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 701,
    height: 744,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaihhalflogo);
export default __webpack_public_path__ + "static/media/taihhalflogo.a3a4cb04f3dac02a8e2c8b4e0077af64.svg";
export { ForwardRef as ReactComponent };